import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=6039bc26&scoped=true"
import script from "./SelectBox.vue?vue&type=script&lang=ts"
export * from "./SelectBox.vue?vue&type=script&lang=ts"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=6039bc26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6039bc26",
  null
  
)

export default component.exports